import { LandingLogo } from '@/components/LandingLogo';
import { COLORS } from '@/constants';
import { createFileRoute } from '@tanstack/react-router'
import { initSDK } from "@/lib/analytics";
import { useEffect, useRef } from 'react';

export const Route = createFileRoute('/(payment)/payment/success')({
    component: RouteComponent,
})

function RouteComponent() {
    const initialized = useRef(false);

    useEffect(() => {
        if (initialized.current) return;
        initialized.current = true;

        initSDK()
    }, [])

    return (
        <div className="flex flex-col justify-center items-center">
            <LandingLogo fill={COLORS.logoRed} width="150px" />
            <p className="text-xl font-bold text-center text-gray-800 sm:text-2xl pb-8">
                Terima kasih, pembayaran berhasil.
            </p>
            <p className="text-l text-center text-gray-800 sm:text-xl">
                Reservasi sudah terkonfirmasi dan detail lengkap telah dikirim via WhatsApp
            </p>
        </div>
    );
}
